import React from 'react';

import { css } from 'glamor';

export default (props = {}) => (
  <svg { ...css({display: 'block', width: props.width || 38, height: props.height || 55 })} xmlns="http://www.w3.org/2000/svg" width="26" height="22" viewBox="0 0 26 22">
    <defs>
      <filter id="a" width="116.7%" height="116.7%" x="-8.3%" y="-4.2%" filterUnits="objectBoundingBox">
        <feOffset dy="1" in="SourceAlpha" result="shadowOffsetOuter1"/>
        <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation=".5"/>
        <feColorMatrix in="shadowBlurOuter1" result="shadowMatrixOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1"/>
          <feMergeNode in="SourceGraphic"/>
        </feMerge>
      </filter>
    </defs>
    <g fill="none" fillRule="evenodd" filter="url(#a)" transform="translate(1 -2)">
      <path fill="#FFF" fillRule="nonzero" d="M1.663 16.612c-.445 0-.806-.342-.806-.765V8.152c0-.422.36-.765.806-.765h3.57l7.013-4.676a.843.843 0 0 1 .835-.054.76.76 0 0 1 .435.679v17.328a.76.76 0 0 1-.433.678.843.843 0 0 1-.834-.052l-7.016-4.678h-3.57z"/>
      <path stroke="#FFF" strokeLinecap="round" strokeWidth="1.5" d="M16.286 15.429a3.429 3.429 0 1 0 0-6.858M18 18c2.147-.534 4.74-2.546 4.74-5.86 0-3.313-2.175-5.27-4.74-6.14"/>
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ../src/client/components/icons/VideoVolumeOn.js